import {
  useInvestmentCorporateActionList as useInvestmentCorporateActionListQuery,
  useInvestmentCorporateActionGet as useInvestmentCorporateActionGetQuery,
  type CorporateActionSurfaceDto,
} from '../../../api/generated/client';
import { ROUTE_IDS, OPERATION_IDS } from '@finance/contracts';
import type { ListHookResult, GetHookResult, ResourceHookBinding } from '../../resource-hook-registry.js';
import { selectApiData, type ApiSuccessEnvelope } from '../../../api/select-api-data.js';

function selectCorporateActionListRows(response: unknown): CorporateActionSurfaceDto[] {
  return selectApiData(response as ApiSuccessEnvelope<CorporateActionSurfaceDto[]>) ?? [];
}

function selectCorporateActionDetail(response: unknown): CorporateActionSurfaceDto {
  return selectApiData(response as ApiSuccessEnvelope<CorporateActionSurfaceDto>);
}

export function useCorporateActionList(): ListHookResult<CorporateActionSurfaceDto[]> {
  return useInvestmentCorporateActionListQuery({ query: { select: selectCorporateActionListRows } });
}

export function useCorporateActionGet(id: string): GetHookResult<CorporateActionSurfaceDto> {
  return useInvestmentCorporateActionGetQuery(id, { query: { select: selectCorporateActionDetail } });
}

export const CORPORATE_ACTIONS_HOOKS: ResourceHookBinding<CorporateActionSurfaceDto[], CorporateActionSurfaceDto> = {
  useList: useCorporateActionList,
  selectList: selectCorporateActionListRows,
  useGet: useCorporateActionGet,
  selectDetail: selectCorporateActionDetail,
  rowIdExtractor: (row) => (typeof row.id === 'string' ? row.id : undefined),
  rowIdField: 'id',
  routeParameterName: 'id',
  paramName: 'id',
  listRouteId: ROUTE_IDS.DATA_CORPORATE_ACTIONS,
  detailRouteId: ROUTE_IDS.DATA_CORPORATE_ACTION_DETAIL,
  readOperationId: OPERATION_IDS.CORPORATE_ACTION_GET,
  detailDescriptorId: 'detail.corporateActions',
};
